import React from 'react';
import { FiLoader } from 'react-icons/fi'

export default function Loader({ loading }) {

  if (!loading) return null;

  return (
    <div className='modal-spinner'>
      <FiLoader className='loader spinner'/>
    </div>
  )
}
